import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-black/90 backdrop-blur-md border-b border-white/10'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1920px] mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <img 
              src="/media/logo-gail-lleyton.png" 
              alt="Gail Lleyton Logo" 
              className="h-12 w-auto transition-transform duration-300 group-hover:scale-105"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
            <span className="text-2xl font-bold tracking-wider text-white group-hover:text-rose-400 transition-colors duration-300">
              GAIL LLEYTON
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="/#about" className="text-gray-300 hover:text-white transition-colors duration-200">À Propos</a>
            <a href="/#discography" className="text-gray-300 hover:text-white transition-colors duration-200">Discographie</a>
            <a href="/#beats" className="text-gray-300 hover:text-white transition-colors duration-200">Beats</a>
            <a href="/#videos" className="text-gray-300 hover:text-white transition-colors duration-200">Vidéos</a>
            <a href="/#services" className="text-gray-300 hover:text-white transition-colors duration-200">Services</a>
            <a href="/#shop" className="text-gray-300 hover:text-white transition-colors duration-200">Boutique</a>
            <a
              href="mailto:contact@GailLleyton.com?subject=%5BSite%20officiel%20%E2%80%93%20Gail%20Lleyton%5D%20Nouveau%20message"
              onClick={(e) => e.stopPropagation()}
              className="px-6 py-2 bg-gradient-to-r from-rose-800 to-violet-800 text-white rounded-full font-medium uppercase text-sm tracking-wider hover:scale-105 transition-transform duration-300 shadow-lg hover:shadow-rose-500/50"
            >
              Contact
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden px-4 pt-2 pb-6 space-y-4 bg-black border-t border-neutral-800">
            <a
              href="/#about"
              className="block w-full text-left py-2 text-gray-300 hover:text-white transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              À Propos
            </a>
            <a
              href="/#discography"
              className="block w-full text-left py-2 text-gray-300 hover:text-white transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Discographie
            </a>
            <a
              href="/#beats"
              className="block w-full text-left py-2 text-gray-300 hover:text-white transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Beats
            </a>
            <a
              href="/#videos"
              className="block w-full text-left py-2 text-gray-300 hover:text-white transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Vidéos
            </a>
            <a
              href="/#services"
              className="block w-full text-left py-2 text-gray-300 hover:text-white transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Services
            </a>
            <a
              href="/#shop"
              className="block w-full text-left py-2 text-gray-300 hover:text-white transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Boutique
            </a>
            <a
              href="mailto:contact@GailLleyton.com?subject=%5BSite%20officiel%20%E2%80%93%20Gail%20Lleyton%5D%20Nouveau%20message"
              onClick={(e) => e.stopPropagation()}
              className="block w-full text-center px-6 py-2 bg-gradient-to-r from-rose-800 to-violet-800 text-white rounded-full font-medium uppercase text-sm tracking-wider shadow-lg"
            >
              Contact
            </a>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;